import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import { booksToolsFactory } from './BooksTools';

export default angular.module('books.util', [csmCommonWeb])
  .factory("BooksTools", booksToolsFactory)
  .name;

